import React, { useState, useEffect } from "react";
import { Breadcrumb, SimpleCard } from "app/components";
import { ValidatorForm } from "react-material-ui-form-validator";

import {
  Button,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Icon,
  TextField,
  MenuItem,
  TableContainer,
  TablePagination,
  Grid,
  Box,
  Typography,
  Divider,
} from "@material-ui/core";
import axios from "axios.js";
import { useHistory } from "react-router-dom";
import { config } from "../../../../../config";
import ConfirmMessage from "../../../Configuration/Message/ConfirmMessage";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { toast } from "react-toastify";
import { useCallback } from "react";

function downloadVoucher(ExpenseId) {
  axios({
    url: config.BASE_API + "/expense/voucher/" + ExpenseId,
    method: "get",
    responseType: "blob", // important
  }).then((response) => {
    if (response?.data?.type === "text/plain") {
      window.alert("No Result Found");
      return;
    }
    //Create a Blob from the PDF Stream
    const file = new Blob([response.data], { type: "application/pdf" });
    //Build a URL from the file
    const fileURL = URL.createObjectURL(file);
    //Open the URL on new Window
    const pdfWindow = window.open();
    pdfWindow.location.href = fileURL;
  });
}

const ExpenseList = () => {
  const history = useHistory();
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [expenseObj, setExpenseObj] = useState({});
  const [reqBody, setReqBody] = useState({});
  const [selectedDateFrom, setSelectedDateFrom] = useState(null);
  const [selectedDateTo, setSelectedDateTo] = useState(null);
  const [branch, setBranches] = useState({});
  const [expenseTypes, setExpenseTypes] = useState({});
  const [confirmMessage, setConfirmMessage] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const handleDateChangeFrom = (date, value) => {
    setSelectedDateFrom(date);
    setReqBody({
      ...reqBody,
      fromDate: date,
    });
  };

  const handleDateChangeTo = (date, value) => {
    setSelectedDateTo(date);
    setReqBody({
      ...reqBody,
      toDate: date,
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // const remove = (id) => {
  //   setConfirmMessage({
  //     ...confirmMessage,
  //     isOpen: false,
  //   });
  //   axios.post(config.BASE_API + "/Expense/" + id).then((res) => {
  //     if (res?.data?.succeeded === true) {
  //       toast.error(res?.data?.message);
  //       fetchAPI();
  //     } else {
  //       toast.error(res?.data?.message);
  //     }
  //   });
  // };

  const fetchAPI = useCallback(
    async (body) => {
      let response = await axios.post(config.BASE_API + "/Expense/Search", {
        page: page,
        rowsPerPage: rowsPerPage,
        keyword: body?.keyword,
        fromDate: body?.fromDate,
        toDate: body?.toDate,
        expenseTypeId: body?.expenseTypeId,
        branchId: body?.branchId,
      });
      response = await response.data;
      setExpenseObj(response.data);
      fetchBranches();
      fetchExpenseTypes();
      setLoading(false);
      if (response?.succeeded === false) {
        toast.error(response.message);
      }
    },
    [page, rowsPerPage]
  );

  async function fetchExpenseTypes() {
    let response = await axios.post(config.BASE_API + "/ExpenseType/Search", {
      page: -1,
    });
    response = await response.data;
    setExpenseTypes(response.data);
  }

  async function fetchBranches() {
    let response = await axios.post(config.BASE_API + "/Branch/Search", {
      page: -1,
    });
    response = await response.data;
    setBranches(response.data);
  }

  const handleSearch = (event) => {
    if (event?.nativeEvent?.submitter?.name === "search") {
      fetchAPI(reqBody);
    } else {
      print(reqBody);
    }
  };

  function print(item) {
    axios({
      url: config.BASE_API + "/Expense/print",
      //url: 'https://localhost:7150/api/CreatePdf',
      method: "post",
      data: {
        keyword: item?.keyword,
        expenseTypeId: reqBody?.expenseTypeId,
        branchId: reqBody?.branchId,
        fromDate: fromDate,
        toDate: toDate,
      },
      responseType: "blob", // important
    }).then((response) => {
      // console.log("Response PDF======>",response?.data?.type)
      if (response?.data?.type === "text/plain") {
        window.alert("No Result Found");
        return;
      }
      //Create a Blob from the PDF Stream
      const file = new Blob([response.data], { type: "application/pdf" });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //Open the URL on new Window
      const pdfWindow = window.open();
      pdfWindow.location.href = fileURL;
    });
  }
  const handleChange = (event) => {
    event.persist();
    setReqBody({
      ...reqBody,
      [event.target.name]: event.target.value,
    });
  };
  const { keyword, fromDate, toDate, expenseTypeId, branchId } = reqBody;

  useEffect(() => {
    fetchAPI(reqBody);
  }, [fetchAPI]);

  return (
    <>
      <div className="m-sm-30">
        <div className="mb-sm-30">
          <Breadcrumb
            routeSegments={[
              { name: "Expense", path: "/expense/expense-list" },
              { name: "Expense List" },
            ]}
          />
        </div>
        <ValidatorForm onSubmit={handleSearch} onError={() => null}>
          <Box marginBottom={2}>
            <SimpleCard>
              <TextField
                className="mr-3"
                label="Search By Keywords"
                name="keyword"
                size="small"
                variant="outlined"
                value={keyword || ""}
                onChange={handleChange}
                style={{ marginTop: 10 }}
              />
              <TextField
                select
                className="mr-3 "
                style={{ marginTop: 10, width: 300 }}
                size="small"
                variant="outlined"
                label="Select Branch"
                name="branchId"
                validators={["required"]}
                errormessages={["This field is required"]}
                value={branchId || ""}
                onChange={handleChange}
              >
                <select value={branchId || ""}></select>
                <MenuItem value="">Select Branch</MenuItem>
                {branch?.item1?.map((item, index) => (
                  <MenuItem value={item?.id} key={index}>
                    {item?.name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                select
                className="mr-3"
                style={{ marginTop: 10, width: 300 }}
                size="small"
                variant="outlined"
                label="Select ExpenseType"
                name="expenseTypeId"
                validators={["required"]}
                errormessages={["This field is required"]}
                value={expenseTypeId || ""}
                onChange={handleChange}
              >
                <select value={expenseTypeId || ""}></select>
                <MenuItem value="">Select ExpenseType</MenuItem>
                {expenseTypes?.item1?.map((expenseType, index) => (
                  <MenuItem value={expenseType?.id} key={index}>
                    {expenseType?.name}
                  </MenuItem>
                ))}
              </TextField>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  className="m-2"
                  margin="none"
                  label="From"
                  inputVariant="outlined"
                  type="text"
                  size="small"
                  autoOk={true}
                  format="dd/MM/yyyy"
                  value={selectedDateFrom}
                  onChange={handleDateChangeFrom}
                />
              </MuiPickersUtilsProvider>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  className="m-2"
                  margin="none"
                  label="To"
                  inputVariant="outlined"
                  type="text"
                  size="small"
                  autoOk={true}
                  format="dd/MM/yyyy"
                  value={selectedDateTo}
                  onChange={handleDateChangeTo}
                />
              </MuiPickersUtilsProvider>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                name="search"
                style={{ marginTop: 10 }}
              >
                Search
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                name="print"
                style={{ marginTop: 10, marginLeft: 10 }}
              >
                Download Pdf
              </Button>
            </SimpleCard>
          </Box>
          {loading ? (
            "Loading"
          ) : (
            <SimpleCard>
              <Grid container justify="space-between">
                <Grid item>
                  <Box marginBottom={2}>
                    <Typography variant="h6" component="h2">
                      Expense List
                    </Typography>
                  </Box>
                </Grid>
                <Grid item>
                  <Box marginBottom={2}>
                    <Button
                      color="primary"
                      variant="contained"
                      size="small"
                      onClick={() => history.push("/expense/expense/addNew")}
                    >
                      + Add New Expense
                    </Button>
                  </Box>
                </Grid>
              </Grid>
              <Divider style={{ background: "gray" }} variant="middle" />
              <div className="w-full overflow-auto">
                <TableContainer style={{ width: "100%", overflowX: "auto" }}>
                  <Table style={{ minWidth: 1500 }}>
                    <TableHead>
                      <TableRow>
                        <TableCell width="15%" className="px-0">
                          Expense No
                        </TableCell>
                        <TableCell width="20%" className="px-0">
                          Expense Type
                        </TableCell>
                        <TableCell width="15%" className="px-0">
                          Branch
                        </TableCell>
                        <TableCell width="20%" className="px-0">
                          Remarks
                        </TableCell>
                        <TableCell width="10%" className="px-0">
                          Amount
                        </TableCell>
                        <TableCell width="10%" className="px-0">
                          Entry Date
                        </TableCell>
                        <TableCell width="10%" className="px-0">
                          Voucher
                        </TableCell>
                        {/* <TableCell className="px-0">Edit</TableCell> */}
                        {/* <TableCell className="px-0">Delete</TableCell> */}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {expenseObj?.item1.map((subscriber, index) => (
                        <TableRow key={index}>
                          <TableCell
                            width="20%"
                            className="px-0 capitalize"
                            align="left"
                          >
                            {subscriber.expenseNo}
                          </TableCell>
                          <TableCell
                            width="20%"
                            className="px-0 capitalize"
                            align="left"
                          >
                            {subscriber.expenseType?.name}
                          </TableCell>
                          <TableCell
                            width="20%"
                            className="px-0 capitalize"
                            align="left"
                          >
                            {subscriber.branch?.name}
                          </TableCell>
                          <TableCell
                            width="20%"
                            className="px-0 capitalize"
                            align="left"
                          >
                            {subscriber.remark}
                          </TableCell>
                          <TableCell
                            width="10%"
                            className="px-0 capitalize"
                            align="left"
                          >
                            {subscriber.amount}
                          </TableCell>
                          <TableCell
                            width="10%"
                            className="px-0 capitalize"
                            align="left"
                          >
                            {subscriber.entryDate?.substring(0, 10)}
                          </TableCell>
                          <TableCell width="10%" className="px-0 " align="left">
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={(e) => downloadVoucher(subscriber.id, e)}
                              name="Download"
                              size="small"
                              style={{ marginTop: 10, marginLeft: 10 }}
                            >
                              <Icon>archive</Icon>
                            </Button>
                          </TableCell>
                          {/* 
                          <TableCell className="px-0">
                            <IconButton
                              onClick={() => {
                                history.push("/expense/" + subscriber.id);
                              }}
                            >
                              <Icon color="primary">edit</Icon>
                            </IconButton>
                          </TableCell> */}
                          {/* <TableCell className="px-0">
                              <IconButton
                                onClick={() => {
                                  setConfirmMessage({
                                    isOpen: true,
                                    title:
                                      "Are you sure to delete this record?",
                                    subTitle: "You can't undo this operation",
                                    onConfirm: () => {
                                      remove(subscriber.id);
                                    },
                                  });
                                }}
                              >
                                <Icon color="error">close</Icon>
                              </IconButton>
                            </TableCell> */}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                <ConfirmMessage
                  confirmMessage={confirmMessage}
                  setConfirmMessage={setConfirmMessage}
                />

                <TablePagination
                  className="px-4"
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  component="div"
                  count={expenseObj?.item2 || 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  backIconButtonProps={{
                    "aria-label": "Previous Page",
                  }}
                  nextIconButtonProps={{
                    "aria-label": "Next Page",
                  }}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />
              </div>
            </SimpleCard>
          )}
        </ValidatorForm>
      </div>
    </>
  );
};

export default ExpenseList;
